<template>
  <div>
    <CustomerAddNew
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />

    <vs-card>
      <b-row class="justify-content-md-start" v-if="!isMobile()">
        <b-col cols="3">
          <b-form-group label-for="item-name">
            <b-form-input
              v-model="searchedVal"
              id="smallInput"
              :placeholder="$t('Search')"
              @keyup.enter="filterCustomerList"
              size="sm"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="auto" style="padding-left: 0px !important">
          <b-button
            class="bg-primary"
            style="border-color: white"
            size="sm"
            v-on:click="filterCustomerList()"
          >
            <Icon
              icon="material-symbols:search-rounded"
              width="20"
              height="20"
            /> </b-button
        ></b-col>
        <b-col>
          <b-row align-h="end">
            <b-col cols="3" md="auto" style="padding-left: 0px !important">
              <b-dropdown
                size="sm"
                id="dropdown-1"
                :text="$t('TotalActions')"
                class="bg-primary"
                style="border-color: white"
              >
                <b-dropdown-item-button
                  @click="
                    wholeStockActions = true;
                    deleteCustomer();
                  "
                >
                  <span class="flex items-center">
                    <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                    <span>{{ $t("Delete") }}</span>
                  </span>
                </b-dropdown-item-button>
              </b-dropdown>
            </b-col>
            <b-col cols="3" md="auto" style="padding-left: 0px !important">
              <success-btn
                :bgcolor="'bg-primary'"
                :title="'AddNew'"
                :icon="'mingcute:add-line'"
                :size="'sm'"
            /></b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="justify-content-md-start" v-else>
        <b-col cols="6">
          <b-form-group label-for="item-name">
            <b-form-input
              v-model="searchedVal"
              id="smallInput"
              :placeholder="$t('Search')"
              @keyup.enter="filterCustomerList"
              size="sm"
            />
          </b-form-group>
        </b-col>

        <b-col cols="2" style="padding-left: 0px !important">
          <b-button
            class="bg-primary"
            style="border-color: white"
            size="sm"
            v-on:click="filterCustomerList()"
          >
            <Icon
              icon="material-symbols:search-rounded"
              width="20"
              height="20"
            /> </b-button
        ></b-col>
        <b-col cols="4" style="padding-left: 0px !important">
          <success-btn
            :bgcolor="'bg-success'"
            :title="'AddNew'"
            :icon="'mingcute:add-line'"
            :size="'sm'"
        /></b-col>
        <b-col>
          <b-dropdown
            size="sm"
            id="dropdown-1"
            :text="$t('TotalActions')"
            class="bg-primary mt-5"
            style="border-color: white"
          >
            <b-dropdown-item-button
              @click="
                wholeStockActions = true;
                deleteCustomer();
              "
            >
              <span class="flex items-center">
                <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>{{ $t("Delete") }}</span>
              </span>
            </b-dropdown-item-button>
          </b-dropdown>
        </b-col>
      </b-row>
      <b-row>
        <ag-grid-vue
          ref="agGridTable"
          class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
          :columnDefs="customerColumns"
          :defaultColDef="defaultColDef"
          :rowData="companyList"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :pagination="true"
          @grid-ready="onGridReady"
          :suppressCopyRowsToClipboard="true"
          :localeText="localeText"
          :suppressRowClickSelection="true"
        >
        </ag-grid-vue>
      </b-row>
    </vs-card>

    <DeleteWarning :isPromptActive="deleteWarningPromptValid" :data="deleteData" />
  </div>
</template>
<script>
import DeleteWarning from "../../components/warning-message/DeleteWarning.vue";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import moment from "moment";
import { Icon } from "@iconify/vue2";
import SuccessBtn from "../../components/vx-button/SuccessBtn.vue";
import CustomerAddNew from "./CustomerAddNew.vue";
import updateDeleteBtnDynamic from "../CellRenderers/updateDeleteBtnDynamic.vue";
import imgShowCellRenderer from "./CellRenderers/imgShowCellRenderer.vue";
import imgShowCellRendererSignLogo from "./CellRenderers/imgShowCellRendererSignLogo.vue";
import { isMobile } from "mobile-device-detect";
import i18nData from "../../i18n/i18nData";
import statusShowCellRenderer from "../CellRenderers/statusShowCellRenderer.vue";

export default {
  components: {
    wholeStockActions: false,
    statusShowCellRenderer,
    imgShowCellRendererSignLogo,
    imgShowCellRenderer,
    AgGridVue,
    Icon,
    SuccessBtn,
    CustomerAddNew,
    updateDeleteBtnDynamic,
    DeleteWarning,
  },
  data() {
    return {
      companyList: [],
      gridApi: null,
      isMobile: function () {
        return isMobile;
      },
      deleteWarningPromptValid: false,
      addNewDataSidebar: false,
      sidebarData: {},
      searchedVal: "",
      companyListFiltered: this.company,
      customerColumns: [],
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      deleteData: [{}],
    };
  },

  methods: {
    deleteSubmitAll() {
      var selectedRows = this.gridApi.getSelectedRows();
      selectedRows.forEach((val, index) => {
        this.deleteSubmit(val);
      });
    },

    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      var defaultSortModel = [{ colId: "CompanyName", sort: "asc", sortIndex: 0 }];
      params.columnApi.applyColumnState({ state: defaultSortModel });
      this.gridApi.refreshCells(params);
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },
    filterCustomerList() {
      this.companyList = this.companyListFiltered;
      this.companyList = this.company.filter((post) => {
        return (
          post.CompanyName.toUpperCase().includes(this.searchedVal.toUpperCase()) ||
          post.CompanyNo.toUpperCase().includes(this.searchedVal.toUpperCase())
        );
      });
    },
    getCustomerList() {
      const vs = this.$vs;
      this.customerColumns = [];
      this.companyListFiltered = this.company;
      this.companyList = this.company;
      try {
        if (this.company.length > 0) {
          let columnList = Object.keys(this.company[0]);
          this.customerColumns.push({
            headerCheckboxSelection: true,
            checkboxSelection: true,
            showDisabledCheckboxes: true,
            width: 130,
            pinned: "left",
            cellRendererFramework: "updateDeleteBtnDynamic",
            cellRendererParams: {
              editMethod: "editDataCustomer",
              deleteMethod: "deleteDataCustomer",
            },
          });
          columnList.forEach((val, index) => {
            if (val == "CompanyLogo") {
              if (this.isMobile())
                this.customerColumns.push({
                  width: 80,
                  headerName: this.$t(val),
                  cellRendererFramework: "imgShowCellRenderer",
                  field: val,
                  filter: "agSetColumnFilter",
                });
              else
                this.customerColumns.push({
                  width: 80,
                  headerName: this.$t(val),
                  cellRendererFramework: "imgShowCellRenderer",
                  pinned: "left",
                  field: val,
                  filter: "agSetColumnFilter",
                });
            } else if (val == "Status")
              this.customerColumns.push({
                width: 80,
                headerName: this.$t(val),
                cellRendererFramework: "statusShowCellRenderer",
                field: val,
                filter: "agSetColumnFilter",
              });
            else if (val == "CompanySignLogo") {
              if (this.isMobile())
                this.customerColumns.push({
                  width: 80,
                  headerName: this.$t(val),
                  cellRendererFramework: "imgShowCellRendererSignLogo",
                  field: val,
                  filter: "agSetColumnFilter",
                });
              else
                this.customerColumns.push({
                  width: 80,
                  headerName: this.$t(val),
                  cellRendererFramework: "imgShowCellRendererSignLogo",
                  pinned: "left",
                  field: val,
                  filter: "agSetColumnFilter",
                });
            } else if (val == "CompanyName" || val == "CompanyNo") {
              if (this.isMobile())
                this.customerColumns.push({
                  headerName: this.$t(val),
                  field: val,
                  filter: "agSetColumnFilter",
                });
              else
                this.customerColumns.push({
                  headerName: this.$t(val),
                  pinned: "left",
                  field: val,
                  filter: "agSetColumnFilter",
                });
            } else if (val != "CompanyId" && val.toString().includes("Date") == false)
              this.customerColumns.push({
                headerName: this.$t(val),
                field: val,
                filter: "agSetColumnFilter",
              });
            else if (val.toString().includes("Date") == true) {
              this.customerColumns.push({
                headerName: this.$t(val),
                field: val,
                filter: "agSetColumnFilter",
                valueFormatter: (params) => this.parseDate(params.data[val]),
              });
            }
          });
          if (this.searchedVal != "") this.filterCustomerList();
        }
      } catch (error) {
        console.log(error);
      }
    },
    updateCustomer(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    deleteCustomer(data) {
      this.deleteWarningPromptValid = true;
    },

    closeDeleteWarning() {
      this.deleteWarningPromptValid = false;
    },
    deleteSubmit(data) {
      const vs = this.$vs;
      this.$store
        .dispatch("customer/deleteCustomer", data.CompanyId)
        .then((response) => {
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.getCustomerList();
              this.deleteWarningPromptValid = false;
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
  },
  created() {
    if (this.company.length == 0) {
      this.$store
        .dispatch("customer/listCustomer")
        .then((response) => {
          if (response) {
            if (response.success == true) {
            } else console.log(response);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    this.getCustomerList();
  },
  watch: {
    company(val) {
      this.getCustomerList();

      return val;
    },
  },
  computed: {
    company: {
      get() {
        return this.$store.state.customer.Customer;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    localeText() {
      return i18nData[this.$i18n.locale];
    },
  },
  mounted() {
    //tables global olarak tanımlanıyor

    this.$root.$on("addNewData", () => {
      this.addNewData();
    });
    this.$root.$on("getCustomerList", () => {
      this.getCustomerList();
    });
    this.$root.$on("editDataCustomer", (data) => {
      this.updateCustomer(data);
    });
    this.$root.$on("deleteDataCustomer", (data) => {
      this.deleteData = data;
      this.deleteCustomer(data);
    });
    this.$root.$on("deleteSubmit", (data) => {
      if (this.wholeStockActions == true) this.deleteSubmitAll();
      else this.deleteSubmit(data);
    });

    this.$root.$on("closeDeleteWarning", () => {
      this.closeDeleteWarning();
    });
  },
  beforeDestroy() {
    this.$root.$off("addNewData");
    this.$root.$off("getCustomerList");
    this.$root.$off("editData");
    this.$root.$off("deleteData");
    this.$root.$off("deleteSubmit");
    this.$root.$off("closeDeleteWarning");
  },
};
</script>
<style lang="scss">
.scroll-to-ag-grid-table {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 140px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
[dir] .btn-group button {
  padding: 4px !important;
}
</style>
